"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "w-full 2xl:container mx-auto p-4 flex flex-col"
};
const _hoisted_2 = {
    key: 1,
    class: "flex flex-col lg:flex-row bg-white gap-2 py-2 px-4 mb-4"
};
const _hoisted_3 = { class: "font-bold" };
const _hoisted_4 = { class: "flex flex-col gap-2" };
const _hoisted_5 = { class: "flex flex-col lg:flex-row gap-2 h-full" };
const _hoisted_6 = {
    key: 0,
    class: "px-2 text-center lg:hidden"
};
const _hoisted_7 = {
    key: 0,
    class: "flex flex-col lg:flex-row gap-2 h-full"
};
const _hoisted_8 = { class: "px-2 text-center lg:hidden" };
const _hoisted_9 = {
    key: 1,
    class: "tag-search-input"
};
const _hoisted_10 = {
    key: 2,
    class: "btn-group !items-stretch self-center"
};
const _hoisted_11 = ["disabled"];
const _hoisted_12 = ["title"];
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-remove" }, null, -1);
const _hoisted_14 = [
    _hoisted_13
];
const _hoisted_15 = {
    key: 0,
    class: "absolute right-0 bg-gray-dark text-white text-xs py-1 px-4 font-bold rounded-b"
};
const _hoisted_16 = {
    key: 4,
    class: "relative flex justify-end"
};
const _hoisted_17 = {
    key: 0,
    class: "bg-gray-dark text-white text-xs py-1 px-4 font-bold rounded-b"
};
const _hoisted_18 = {
    key: 5,
    class: "flex flex-row lg:hidden items-center bg-gray-dark mt-4"
};
const _hoisted_19 = { key: 0 };
const _hoisted_20 = { key: 1 };
const vue_3 = require("vue");
const DropdownInput_vue_1 = __importDefault(require("../Form/DropdownInput/DropdownInput.vue"));
const Form_1 = require("../Form");
const TagSearchInput_vue_1 = __importDefault(require("./TagSearchInput.vue"));
const tyre_search_1 = require("./tyre-search");
const Alert_vue_1 = __importDefault(require("../Alert.vue"));
const ProductPopup_vue_1 = __importDefault(require("../ProductPopup.vue"));
const DiscountPopup_vue_1 = __importDefault(require("../DiscountPopup.vue"));
const i18n_1 = require("../../common/i18n");
const vue_router_1 = require("vue-router");
const shop_1 = require("../../common/utils/shop");
const DropdownInputItem_1 = __importDefault(require("../Form/DropdownInput/DropdownInputItem"));
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const customDesignStore_1 = require("../../stores/customDesign/customDesignStore");
const Banner_vue_1 = __importDefault(require("../Banner.vue"));
const BannerFile_1 = require("../../stores/banner/BannerFile");
const GroupDropdownInput_vue_1 = __importDefault(require("../Form/GroupDropdownInput/GroupDropdownInput.vue"));
const productListStore_1 = require("../../stores/product/list/productListStore");
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const ProductListTable_vue_1 = __importDefault(require("../ProductListTable/ProductListTable.vue"));
const tagStore_1 = require("../../stores/tag/tagStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TyreFilter',
    props: {
        searchLabel: {
            type: String,
            default: "Tyre Search",
        },
        needTagSearch: {
            type: Boolean,
            default: true,
        },
        hasAdditionalFilters: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Object,
            default: (0, vue_3.ref)(tyre_search_1.tyreSearchForm),
        },
        category: {
            type: String,
            default: "carTyre",
        },
        placeholder: {
            type: String,
            default: "",
        },
    },
    setup(__props, { expose }) {
        const props = __props;
        const SortBy = {
            NAME: 'name',
            LIST_PRICE: 'listPrice',
            WHOLESALE_PRICE: 'wholesalePrice',
            RETAIL_PRICE: 'retailPrice',
            CUSTOM_PRICE: 'customPrice',
            STOCK: 'stock'
        };
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const customDesignStore = (0, customDesignStore_1.useCustomDesignStore)();
        const productListStore = (0, productListStore_1.useProductListStore)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const tagStore = (0, tagStore_1.useTagStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const filterValues = (0, vue_3.computed)(() => productFilterStore.productFilters);
        const tagSearchInputRef = (0, vue_3.ref)(null);
        const carTyreBrandDropdownInputItems = (0, vue_3.ref)({});
        const brandGroupDropdownKey = (0, vue_3.ref)(0);
        const pairSearchLoading = (0, vue_3.ref)(false);
        const shouldShowPairSearch = (0, vue_3.computed)(() => {
            return ShopConfig_1.ShopConfig.shouldShowPairSearchForType(props.category);
        });
        const currentRouteIsSkuSearch = (0, vue_3.computed)(() => {
            return router.currentRoute.value.name === 'shop_sku_search';
        });
        // Aktuális találatok száma a szűrések figyelembevételével.
        const currentHitsCount = (0, vue_3.computed)(() => {
            var _a, _b;
            // Ha még nincsenek betöltve a termékek, akkor az eredeti filterValues értéket mutatjuk.
            if (((_b = (_a = filterValues.value) === null || _a === void 0 ? void 0 : _a.itemCount) === null || _b === void 0 ? void 0 : _b.values) && products.value.length === 0) {
                return typeof filterValues.value.itemCount.values === 'number' ? filterValues.value.itemCount.values : 0;
            }
            // Egyébként a szűrt termékek számát mutatjuk.
            return products.value.length;
        });
        // SZGK kategória esetén, ha van márka csoportosítás, akkor azt használjuk.
        const brandDropdownInputItems = (0, vue_3.computed)(() => {
            const baseBrandItems = productFilterStore.brandDropdownInputItems;
            if (props.category === 'carTyre' && carTyreBrandDropdownInputItems.value && Object.keys(carTyreBrandDropdownInputItems.value).length > 0) {
                const baseCodes = new Set(baseBrandItems.map((item) => item.value));
                // Szűrjük le a carTyreBrandDropdownInputItems-t, hogy csak a baseBrandItems-ben lévő kódokat tartalmazza.
                const filtered = {};
                Object.entries(carTyreBrandDropdownInputItems.value).forEach(([group, obj]) => {
                    const filteredItems = obj.items.filter((item) => baseCodes.has(item.value));
                    if (filteredItems.length > 0) {
                        filtered[group] = { items: filteredItems };
                    }
                });
                return filtered;
            }
            return baseBrandItems;
        });
        const widthDropdownInputItems = (0, vue_3.computed)(() => {
            return productFilterStore.widthDropdownInputItems;
        });
        const profileDropdownInputItems = (0, vue_3.computed)(() => {
            return productFilterStore.profileDropdownInputItems;
        });
        const diameterDropdownInputItems = (0, vue_3.computed)(() => {
            return productFilterStore.diameterDropdownInputItems;
        });
        const widthPairDropdownInputItems = (0, vue_3.computed)(() => {
            return productFilterStore.widthPairDropdownInputItems;
        });
        const profilePairDropdownInputItems = (0, vue_3.computed)(() => {
            return productFilterStore.profilePairDropdownInputItems;
        });
        const diameterPairDropdownInputItems = (0, vue_3.computed)(() => {
            return productFilterStore.diameterPairDropdownInputItems;
        });
        const isToggleWrapperVisible = (0, vue_3.computed)(() => {
            // Ha egyik kapcsoló sem látható, akkor a toggle wrapper se legyen az.
            if (!tagStore.tags.switches.zeroStockSwitch.display &&
                !tagStore.tags.switches.setSwitch.display &&
                !tagStore.tags.switches.retailPriceSwitch.display &&
                !tagStore.tags.switches.grossPriceSwitch.display &&
                (!shouldShowPairSearch.value || !tagStore.tags.switches.pairSearchSwitch.display)) {
                return false;
            }
            else {
                return true;
            }
        });
        // A függvény egy adott propertyName nevű tulajdonsághoz két computed változót hoz létre.
        const createPropertyPair = (propertyName) => {
            // Az első érték (pl. width[0]).
            const first = (0, vue_3.computed)({
                get: () => { var _a, _b; return (_b = (_a = props.form[propertyName]) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null; },
                set: (val) => {
                    // Ha a property nem tömb, létrehozunk egy tömböt, amiben két érték van.
                    if (!Array.isArray(props.form[propertyName])) {
                        // eslint-disable-next-line vue/no-mutating-props
                        props.form[propertyName] = [val, null];
                    }
                    else {
                        // Ha már tömb, az első értéket módosítjuk.
                        // eslint-disable-next-line vue/no-mutating-props
                        props.form[propertyName][0] = val;
                    }
                }
            });
            // A második érték (pl. width[1]).
            const second = (0, vue_3.computed)({
                get: () => { var _a, _b; return (_b = (_a = props.form[propertyName]) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : null; },
                set: (val) => {
                    // Ha a property nem tömb, létrehozunk egy tömböt, amiben két érték van.
                    if (!Array.isArray(props.form[propertyName])) {
                        // eslint-disable-next-line vue/no-mutating-props
                        props.form[propertyName] = [null, val];
                    }
                    else {
                        // Ha már tömb, a második értéket módosítjuk.
                        // eslint-disable-next-line vue/no-mutating-props
                        props.form[propertyName][1] = val;
                    }
                }
            });
            // A függvény visszaadja az első és második computed értéket egy tömbben.
            return [first, second];
        };
        // Példányosítjuk a createPropertyPair-t különböző a szükséges property nevekkel.
        const [width, widthPair] = createPropertyPair('width');
        const [profile, profilePair] = createPropertyPair('profile');
        const [diameter, diameterPair] = createPropertyPair('diameter');
        // Méretsorok értékeinek figyelése.
        (0, vue_3.watch)([width, profile, diameter, widthPair, profilePair, diameterPair], () => {
            const values = [
                { first: width, second: widthPair, key: 'width' },
                { first: profile, second: profilePair, key: 'profile' },
                { first: diameter, second: diameterPair, key: 'diameter' },
            ];
            // Ha az első és a második méretsor bármelyik kapcsolódó értékei null-ok,
            // akkor állítsuk null-ra az adott form-hoz tartozó értéket.
            values.forEach(({ first, second, key }) => {
                if (!first.value && !second.value) {
                    // eslint-disable-next-line vue/no-mutating-props
                    props.form[key] = null;
                }
            });
        });
        (0, vue_3.onBeforeUnmount)(() => {
            productListStore.reset();
        });
        const hasFormValues = () => {
            for (const key in props.form) {
                if (key !== "type" && key !== "axCategory" && key !== "axCategories") {
                    if (props.form[key] !== null) {
                        return true;
                    }
                }
            }
            return false;
        };
        (0, vue_3.watch)(() => props.form, (form) => {
            let queryParams = (0, tyre_search_1.getQueryParams)(form);
            applySearchParams(queryParams, form);
            productFilterStore.getProductFilters(router, queryParams)
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        }, { deep: true });
        const isMobile = () => {
            let currentBreakpoint = (0, shop_1.getCurrentBreakpoint)();
            return currentBreakpoint === "md" || currentBreakpoint === "sm";
        };
        const urlSearchParams = window.location.search.length;
        const isFiltersClosed = (0, vue_3.ref)(urlSearchParams > 0 && isMobile());
        const isAdditionalFiltersClosed = (0, vue_3.ref)(urlSearchParams > 0);
        const zeroStockToggle = (0, vue_3.ref)(false);
        const retailPriceToggle = (0, vue_3.ref)(false);
        const showGrossPriceToggle = (0, vue_3.ref)(false);
        const tyreSetStockToggle = (0, vue_3.ref)(false);
        const pairSearchToggle = (0, vue_3.ref)(false);
        const sortItemsBy = [
            new DropdownInputItem_1.default("name", (0, i18n_1.trans)("product_name", "Product name", "tyre_filter")),
            new DropdownInputItem_1.default("stock", (0, i18n_1.trans)("stock", "Stock", "tyre_filter")),
            new DropdownInputItem_1.default("listPrice", (0, i18n_1.trans)("list_price", "List price", "tyre_filter")),
            new DropdownInputItem_1.default("wholesalePrice", (0, i18n_1.trans)("wholesale_price", "Wholesale price", "tyre_filter")),
        ];
        const sortByAscOrDescToggle = () => sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc';
        (0, vue_3.onBeforeMount)(async () => {
            var _a;
            if (localStorage) {
                showGrossPriceToggle.value = "true" === localStorage.getItem("showGrossPriceToggle");
                pairSearchToggle.value = "true" === localStorage.getItem(`pairSearchToggle_${props.category}`);
            }
            setSizeOptions(props.form.sizeSlug);
            try {
                let queryParams = (0, tyre_search_1.getQueryParams)(props.form);
                applySearchParams(queryParams, props.form);
                pairSearchLoading.value = true;
                try {
                    if (currentRouteIsSkuSearch.value && !props.form['id'] && !props.form['manufacturerSku'] && !props.form['ean']) {
                        return;
                    }
                    await productFilterStore.getProductFilters(router, queryParams);
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
                finally {
                    pairSearchLoading.value = false;
                }
                if (currentRouteIsSkuSearch.value) {
                    await getProducts();
                }
                else {
                    if (typeof ((_a = filterValues === null || filterValues === void 0 ? void 0 : filterValues.value) === null || _a === void 0 ? void 0 : _a.itemCount.values) === "number") {
                        if (filterValues.value.itemCount.values <= tyre_search_1.MAX_HITS && hasFormValues()) {
                            await getProducts();
                        }
                    }
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        });
        (0, vue_3.watch)(showGrossPriceToggle, (showGrossPriceToggle) => {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("showGrossPriceToggle", showGrossPriceToggle.toString());
        });
        (0, vue_3.watch)(pairSearchToggle, async (value) => {
            let queryParams = (0, tyre_search_1.getQueryParams)(props.form);
            applySearchParams(queryParams, props.form);
            pairSearchLoading.value = true;
            try {
                await productFilterStore.getProductFilters(router, queryParams);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
            finally {
                pairSearchLoading.value = false;
            }
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("pairSearchToggle_" + props.category, value.toString());
        });
        (0, vue_3.watch)(tyreSetStockToggle, (tyreSetStockToggleValue) => {
            if (tyreSetStockToggleValue) {
                zeroStockToggle.value = false;
            }
        });
        (0, vue_3.watch)(zeroStockToggle, (zeroStockToggleValue) => {
            if (zeroStockToggleValue) {
                tyreSetStockToggle.value = false;
            }
        });
        const getProducts = async () => {
            let queryParams = (0, tyre_search_1.getQueryParams)(props.form);
            if (typeof queryParams.axCategories !== "undefined") {
                queryParams.axCategory = queryParams.axCategories;
                delete queryParams.axCategories;
            }
            if (typeof queryParams.homologatedNotations !== "undefined") {
                queryParams.homologatedNotation = queryParams.homologatedNotations;
                delete queryParams.homologatedNotations;
            }
            if (typeof queryParams.ids !== "undefined") {
                queryParams.id = queryParams.ids;
                delete queryParams.ids;
            }
            if (typeof queryParams.eans !== "undefined") {
                queryParams.ean = queryParams.eans;
                delete queryParams.eans;
            }
            if (typeof queryParams.manufacturerSkus !== "undefined") {
                queryParams.manufacturerSku = queryParams.manufacturerSkus;
                delete queryParams.manufacturerSkus;
            }
            applySearchParams(queryParams, props.form);
            productListStore.getProducts(router, queryParams)
                .then(() => {
                var _a;
                router.push({
                    name: (_a = router.currentRoute.value.name) !== null && _a !== void 0 ? _a : "shop_passenger_tyres",
                    query: queryParams,
                });
            })
                .catch((e) => {
                console.error(e);
            });
            if (router.currentRoute.value.name === 'shop_sku_search') {
                zeroStockToggle.value = true;
            }
        };
        const sortBy = (0, vue_3.ref)(SortBy.NAME);
        const sortDir = (0, vue_3.ref)('asc');
        const products = (0, vue_3.computed)(() => {
            let products = productListStore.list;
            let filtered = [];
            let minNumOfProducts = 0;
            if (!zeroStockToggle.value) {
                // ha nincs behuzva a nullas keszlet, akkor 1-re noveljuk
                minNumOfProducts = 1;
                if (tyreSetStockToggle.value) {
                    // ha a szett kapcsolo be van huzva, akkor
                    // a par kapcsolotol fuggoen 2-re vagy 4-re allitjuk
                    minNumOfProducts = pairSearchToggle.value ? 2 : 4;
                }
            }
            for (const product of products) {
                let currentQuickStock = product.stocks.stockCountry;
                if (product.stocks.stockExpress) {
                    // ha van express keszlet, akkor hozzaadjuk
                    currentQuickStock += product.stocks.stockExpress;
                }
                if (product.stocks.stockManufacturer) {
                    // gyártói készlet
                    currentQuickStock += product.stocks.stockManufacturer;
                }
                if (product.stocks.stockHun) {
                    // magyarországi készlet RO, SR esetén
                    currentQuickStock += product.stocks.stockHun;
                }
                if (product.priceOptions) {
                    product.priceOptions.forEach((priceOption) => {
                        if (priceOption.stock) {
                            currentQuickStock += priceOption.stock;
                        }
                    });
                }
                if (currentQuickStock >= minNumOfProducts) {
                    filtered.push(product);
                }
            }
            return filtered;
        });
        const resetFilters = () => {
            router.push(router.currentRoute.value.path).then(() => {
                window.location.reload();
            });
        };
        const resetTagSearchInput = () => {
            var _a;
            (_a = tagSearchInputRef.value) === null || _a === void 0 ? void 0 : _a.resetTags();
        };
        const searchString = (0, vue_3.ref)("");
        const handleSearchStringUpdate = (value) => {
            searchString.value = value;
        };
        const handleKeyPress = (event) => {
            var _a, _b;
            if (event.key === "Enter") {
                if (!((_b = (_a = filterValues.value) === null || _a === void 0 ? void 0 : _a.itemCount) === null || _b === void 0 ? void 0 : _b.values) ||
                    typeof filterValues.value.itemCount.values !== "number" ||
                    filterValues.value.itemCount.values <= tyre_search_1.MAX_HITS) {
                    if (event.target instanceof HTMLElement &&
                        searchString.value == "") {
                        getProducts();
                        isAdditionalFiltersClosed.value = true;
                        if (isMobile()) {
                            isFiltersClosed.value = true;
                        }
                        event.target.blur();
                    }
                }
            }
            else if (event.key === "Backspace") {
                resetTagSearchInput();
            }
        };
        // Kategória váltáskor ellenőrizzük, hogy van-e az SZGK kategóriához márka csoportosítás, ha van, akkor azt beállítjuk.
        const fetchAndTransformBrandPriceCategories = async () => {
            // Ha cikkszám kereső oldalon vagyunk, akkor ne töltsünk be márka csoportosítást.
            if (currentRouteIsSkuSearch.value)
                return;
            try {
                const brandPriceCategories = await productFilterStore.getBrandPriceCategories(router);
                if (brandPriceCategories && Object.entries(brandPriceCategories).length > 0) {
                    const transformedData = {};
                    Object.entries(brandPriceCategories).forEach(([categoryName, brands]) => {
                        transformedData[categoryName] = {
                            items: brands.map((brand) => new DropdownInputItem_1.default(brand.code, brand.name)),
                        };
                    });
                    carTyreBrandDropdownInputItems.value = transformedData;
                    brandGroupDropdownKey.value += 1;
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const getSizeSlugs = (form) => {
            var _a, _b, _c, _d, _e, _f;
            const widths = form.width || [];
            const profiles = form.profile || [];
            const diameters = form.diameter || [];
            const sizeSlugs = [];
            // Első sizeSlug mindig megy.
            const firstSlug = [
                (_a = widths[0]) !== null && _a !== void 0 ? _a : '*',
                (_b = profiles[0]) !== null && _b !== void 0 ? _b : '*',
                (_c = diameters[0]) !== null && _c !== void 0 ? _c : '*'
            ].join('~');
            sizeSlugs.push(firstSlug);
            // Második csak akkor, ha pairSearchToggle aktív.
            if (pairSearchToggle.value) {
                const secondSlug = [
                    (_d = widths[1]) !== null && _d !== void 0 ? _d : '*',
                    (_e = profiles[1]) !== null && _e !== void 0 ? _e : '*',
                    (_f = diameters[1]) !== null && _f !== void 0 ? _f : '*'
                ].join('~');
                sizeSlugs.push(secondSlug);
            }
            return sizeSlugs;
        };
        const applySearchParams = (queryParams, form) => {
            // Kategóriák, amelyek támogatják a sizeSlug-ot.
            const categoriesWithSizeSlug = ['carTyre', 'truckTyre', 'industrialTyre', 'agriculturalTyre', 'motorcycleTyre', 'rim'];
            // SKU keresőnél ne használjunk sizeSlug-ot, mert ott specifikus termékeket keresünk azonosító alapján.
            // Más kategóriák esetén csak akkor használjunk sizeSlug-ot, ha a kategória (vagy form.type) támogatja (alternatív méretek funkció erre épül).
            const formType = form['type'];
            const typesToCheck = Array.isArray(formType) ? formType : [props.category];
            const allTypesSupportSizeSlug = typesToCheck.every(type => categoriesWithSizeSlug.includes(type));
            if (!currentRouteIsSkuSearch.value && allTypesSupportSizeSlug) {
                queryParams.sizeSlug = getSizeSlugs(form);
                delete queryParams.width;
                delete queryParams.profile;
                delete queryParams.diameter;
            }
            // A pairSearch specifikus state-et csak akkor állítsuk be, ha engedélyezve van.
            if (shouldShowPairSearch.value) {
                queryParams.isPairSearchActive = pairSearchToggle.value;
            }
        };
        const setSizeOptions = (sizeSlugs) => {
            if (!sizeSlugs || sizeSlugs.length === 0)
                return;
            const [first, second] = sizeSlugs;
            if (first) {
                const [w, p, d] = first.split('~');
                width.value = w && w !== '*' ? w : null;
                profile.value = p && p !== '*' ? p : null;
                diameter.value = d && d !== '*' ? d : null;
            }
            if (second) {
                const [w, p, d] = second.split('~');
                widthPair.value = w && w !== '*' ? w : null;
                profilePair.value = p && p !== '*' ? p : null;
                diameterPair.value = d && d !== '*' ? d : null;
            }
        };
        (0, vue_3.watch)(() => customDesignStore.isCustomPriceViewActive, async () => {
            if (!currentUser.value)
                return;
            // A toggle változásának megfelelően állítjuk be a isCustomPriceViewActive változót(mentjük a böngészőbe is) és a design-t.
            if (customDesignStore.isCustomPriceViewActive) {
                await customDesignStore.toggleCustomPriceView(currentUser.value, true);
                showGrossPriceToggle.value = true;
            }
            else {
                await customDesignStore.toggleCustomPriceView(currentUser.value, false);
            }
        });
        (0, vue_3.watch)(() => props.category, async (newCategory) => {
            if (localStorage) {
                pairSearchToggle.value = "true" === localStorage.getItem(`pairSearchToggle_${newCategory}`);
            }
            if (!shouldShowPairSearch.value) {
                pairSearchToggle.value = false;
            }
            if (newCategory === "carTyre") {
                await fetchAndTransformBrandPriceCategories();
            }
        }, { immediate: true });
        (0, vue_3.watch)(() => { var _a, _b; return (_b = (_a = filterValues.value) === null || _a === void 0 ? void 0 : _a.itemCount) === null || _b === void 0 ? void 0 : _b.values; }, () => {
            productListStore.list = [];
        });
        expose({
            resetTagSearchInput,
            search: getProducts,
            resetFilters
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (((0, vue_2.unref)(filterValues) && (0, vue_2.unref)(filterValues).itemCount) || (0, vue_2.unref)(currentRouteIsSkuSearch))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.BannerPermissionEnum).BANNER_READ)) && !(0, vue_2.unref)(customDesignStore).isCustomPriceViewActive)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Banner_vue_1.default, {
                            key: 0,
                            type: (0, vue_2.unref)(BannerFile_1.BannerFileTypeEnum).SEARCH_PAGE
                        }, null, 8, ["type"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.unref)(isToggleWrapperVisible))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            ((0, vue_2.unref)(tagStore).tags.switches.zeroStockSwitch.display)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.Toggle), {
                                    key: 0,
                                    modelValue: zeroStockToggle.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((zeroStockToggle).value = $event)),
                                    label: (0, vue_2.unref)(i18n_1.trans)('zero_stock_toggle_label', '0 stock', 'tyre_filter'),
                                    class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                                }, null, 8, ["modelValue", "label"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(tagStore).tags.switches.setSwitch.display)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.Toggle), {
                                    key: 1,
                                    modelValue: tyreSetStockToggle.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((tyreSetStockToggle).value = $event)),
                                    label: (0, vue_2.unref)(i18n_1.trans)('set_toggle_label_set', 'Set', 'tyre_filter'),
                                    class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                                }, null, 8, ["modelValue", "label"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(tagStore).tags.switches.retailPriceSwitch.display)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.Toggle), {
                                    key: 2,
                                    modelValue: retailPriceToggle.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((retailPriceToggle).value = $event)),
                                    label: (0, vue_2.unref)(i18n_1.trans)('retail_price_toggle_label', 'Retail price', 'tyre_filter'),
                                    class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                                }, null, 8, ["modelValue", "label"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.display)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.Toggle), {
                                    key: 3,
                                    modelValue: showGrossPriceToggle.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((showGrossPriceToggle).value = $event)),
                                    label: (0, vue_2.unref)(i18n_1.trans)('gross_price_toggle_label_gross', 'Gross', 'tyre_filter'),
                                    class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                                }, null, 8, ["modelValue", "label"]))
                                : (0, vue_2.createCommentVNode)("", true),
                            ((0, vue_2.unref)(shouldShowPairSearch) && (0, vue_2.unref)(tagStore).tags.switches.pairSearchSwitch.display)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(Form_1.Toggle), {
                                    key: 4,
                                    modelValue: pairSearchToggle.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((pairSearchToggle).value = $event)),
                                    label: (0, vue_2.unref)(i18n_1.trans)('pair_search_toggle', 'Pair search', 'tyre_filter'),
                                    class: "flex-1 bg-gray justify-between whitespace-nowrap py-2 px-4"
                                }, null, 8, ["modelValue", "label"]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("button", {
                        class: "w-full bg-gray-dark text-white flex items-center justify-between gap-1 py-2 px-4",
                        onClick: _cache[5] || (_cache[5] = ($event) => {
                            isFiltersClosed.value = !isFiltersClosed.value;
                            isAdditionalFiltersClosed.value = isFiltersClosed.value;
                        })
                    }, [
                        (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)(__props.searchLabel), 1),
                        (0, vue_2.createElementVNode)("i", {
                            class: (0, vue_2.normalizeClass)(["marso-icon-chevron-down text-xs transform-gpu transition-transform", { 'rotate-180': !isFiltersClosed.value }]),
                            "aria-hidden": "true"
                        }, null, 2)
                    ]),
                    (0, vue_2.createElementVNode)("div", {
                        class: (0, vue_2.normalizeClass)(["filters", { closed: isFiltersClosed.value }])
                    }, [
                        (0, vue_2.renderSlot)(_ctx.$slots, "filtersPrepend"),
                        (0, vue_2.renderSlot)(_ctx.$slots, "defaultFilters", {}, () => [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                    (pairSearchToggle.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('first_size', 'First size', 'tyre_filter')), 1))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(width),
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((0, vue_2.isRef)(width) ? (width).value = $event : null)),
                                        placeholder: (0, vue_2.unref)(i18n_1.trans)('width', 'Width', 'tyre_filter'),
                                        items: (0, vue_2.unref)(widthDropdownInputItems),
                                        class: "lg:w-32 h-full"
                                    }, null, 8, ["modelValue", "placeholder", "items"]),
                                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(profile),
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((0, vue_2.isRef)(profile) ? (profile).value = $event : null)),
                                        placeholder: (0, vue_2.unref)(i18n_1.trans)('profile', 'Profile', 'tyre_filter'),
                                        items: (0, vue_2.unref)(profileDropdownInputItems),
                                        class: "lg:w-32 h-full"
                                    }, null, 8, ["modelValue", "placeholder", "items"]),
                                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                        modelValue: (0, vue_2.unref)(diameter),
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((0, vue_2.isRef)(diameter) ? (diameter).value = $event : null)),
                                        placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'tyre_filter'),
                                        items: (0, vue_2.unref)(diameterDropdownInputItems),
                                        class: "lg:w-32 h-full"
                                    }, null, 8, ["modelValue", "placeholder", "items"])
                                ]),
                                (pairSearchToggle.value && !pairSearchLoading.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                        (0, vue_2.createElementVNode)("p", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('second_size', 'Second size', 'tyre_filter')), 1),
                                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(widthPair),
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((0, vue_2.isRef)(widthPair) ? (widthPair).value = $event : null)),
                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('width', 'Width', 'tyre_filter'),
                                            items: (0, vue_2.unref)(widthPairDropdownInputItems),
                                            class: "lg:w-32 h-full"
                                        }, null, 8, ["modelValue", "placeholder", "items"]),
                                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(profilePair),
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((0, vue_2.isRef)(profilePair) ? (profilePair).value = $event : null)),
                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('profile', 'Profile', 'tyre_filter'),
                                            items: (0, vue_2.unref)(profilePairDropdownInputItems),
                                            class: "lg:w-32 h-full"
                                        }, null, 8, ["modelValue", "placeholder", "items"]),
                                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                            modelValue: (0, vue_2.unref)(diameterPair),
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((0, vue_2.isRef)(diameterPair) ? (diameterPair).value = $event : null)),
                                            placeholder: (0, vue_2.unref)(i18n_1.trans)('diameter', 'Diameter', 'tyre_filter'),
                                            items: (0, vue_2.unref)(diameterPairDropdownInputItems),
                                            class: "lg:w-32 h-full"
                                        }, null, 8, ["modelValue", "placeholder", "items"])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]),
                            ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(GroupDropdownInput_vue_1.default, {
                                id: "tyre-filter-brand-dropdown",
                                key: brandGroupDropdownKey.value,
                                modelValue: __props.form.brandCode,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((__props.form.brandCode) = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('brands', 'Brands', 'tyre_filter'),
                                items: (0, vue_2.unref)(brandDropdownInputItems),
                                class: "min-w-32"
                            }, null, 8, ["modelValue", "placeholder", "items"]))
                        ]),
                        (__props.needTagSearch)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TagSearchInput_vue_1.default, {
                                key: 0,
                                ref_key: "tagSearchInputRef",
                                ref: tagSearchInputRef,
                                width: __props.form.width,
                                "onUpdate:width": _cache[13] || (_cache[13] = ($event) => ((__props.form.width) = $event)),
                                profile: __props.form.profile,
                                "onUpdate:profile": _cache[14] || (_cache[14] = ($event) => ((__props.form.profile) = $event)),
                                diameter: __props.form.diameter,
                                "onUpdate:diameter": _cache[15] || (_cache[15] = ($event) => ((__props.form.diameter) = $event)),
                                brandCode: __props.form.brandCode,
                                "onUpdate:brandCode": _cache[16] || (_cache[16] = ($event) => ((__props.form.brandCode) = $event)),
                                treadCode: __props.form.treadCode,
                                "onUpdate:treadCode": _cache[17] || (_cache[17] = ($event) => ((__props.form.treadCode) = $event)),
                                "is-pair-search-active": pairSearchToggle.value,
                                form: __props.form,
                                category: __props.category,
                                placeholder: __props.placeholder,
                                class: "sm:block order-first lg:order-none",
                                "query-params": { type: __props.category },
                                "onUpdate:searchString": handleSearchStringUpdate,
                                onKeydown: handleKeyPress
                            }, null, 8, ["width", "profile", "diameter", "brandCode", "treadCode", "is-pair-search-active", "form", "category", "placeholder", "query-params"]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9)),
                        (!(0, vue_2.unref)(currentRouteIsSkuSearch) && ((_b = (0, vue_2.unref)(filterValues)) === null || _b === void 0 ? void 0 : _b.itemCount))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-primary",
                                    disabled: typeof (0, vue_2.unref)(filterValues).itemCount.values === 'number' && (0, vue_2.unref)(filterValues).itemCount.values > (0, vue_2.unref)(tyre_search_1.MAX_HITS),
                                    onClick: _cache[18] || (_cache[18] = ($event) => {
                                        getProducts();
                                        isAdditionalFiltersClosed.value = true;
                                        isMobile() ? (isFiltersClosed.value = true) : '';
                                    })
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("search", "Search", "tyre_filter")), 9, _hoisted_11),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-neutral !bg-gray",
                                    type: "reset",
                                    title: (0, vue_2.unref)(i18n_1.trans)('reset_filters', 'Reset filters', 'tyre_filter'),
                                    onClick: _cache[19] || (_cache[19] = ($event) => (resetFilters()))
                                }, _hoisted_14, 8, _hoisted_12)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ], 2),
                    (__props.hasAdditionalFilters)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 2,
                            class: (0, vue_2.normalizeClass)(["additional-filters", { closed: isAdditionalFiltersClosed.value }])
                        }, [
                            (0, vue_2.renderSlot)(_ctx.$slots, "additionalFilters")
                        ], 2))
                        : (0, vue_2.createCommentVNode)("", true),
                    (__props.hasAdditionalFilters)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 3,
                            class: (0, vue_2.normalizeClass)(["additional-filters-close-btn btn-rounded relative flex justify-center", { closed: isFiltersClosed.value }])
                        }, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "bg-gray-dark text-white rounded-b uppercase py-1 px-4 text-xs font-bold flex justify-between items-center gap-2",
                                onClick: _cache[20] || (_cache[20] = ($event) => (isAdditionalFiltersClosed.value = !isAdditionalFiltersClosed.value))
                            }, [
                                (!isAdditionalFiltersClosed.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("hide_filters", "Hide filters", "tyre_filter")), 1)
                                    ], 64))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("show_filters", "Show filters", "tyre_filter")), 1)
                                    ], 64)),
                                (0, vue_2.createElementVNode)("i", {
                                    class: (0, vue_2.normalizeClass)(["marso-icon-chevron-up transform-gpu transition-transform", { 'rotate-180': isAdditionalFiltersClosed.value }]),
                                    "aria-hidden": "true"
                                }, null, 2)
                            ]),
                            (!(0, vue_2.unref)(currentRouteIsSkuSearch) && ((_c = (0, vue_2.unref)(filterValues)) === null || _c === void 0 ? void 0 : _c.itemCount))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("hits_label_right", "{hits} hits", "tyre_filter", {
                                    hits: (0, vue_2.unref)(i18n_1.n)((0, vue_2.unref)(currentHitsCount), "roundedDecimal"),
                                })), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ], 2))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                            (!(0, vue_2.unref)(currentRouteIsSkuSearch) && ((_d = (0, vue_2.unref)(filterValues)) === null || _d === void 0 ? void 0 : _d.itemCount))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("hits_label", "{hits} hits", "tyre_filter", {
                                    hits: (0, vue_2.unref)(i18n_1.n)((0, vue_2.unref)(currentHitsCount), "roundedDecimal"),
                                })), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])),
                    ((0, vue_2.unref)(router).currentRoute.value.name !== 'shop_sku_search')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                modelValue: sortBy.value,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((sortBy).value = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('sort_by', 'Sort by', 'tyre_filter'),
                                items: sortItemsBy,
                                "disable-deselect": true,
                                class: "w-full bg-white"
                            }, null, 8, ["modelValue", "placeholder"]),
                            (0, vue_2.createElementVNode)("div", {
                                class: "flex flex-col pr-6 pl-6 cursor-pointer",
                                onClick: sortByAscOrDescToggle
                            }, [
                                (0, vue_2.createElementVNode)("i", {
                                    class: (0, vue_2.normalizeClass)(["marso-icon-sort-asc", sortDir.value !== 'desc' ? 'text-white' : 'text-gray']),
                                    style: (0, vue_2.normalizeStyle)(sortDir.value === 'desc' ? '--tw-text-opacity: 0.5' : '--tw-text-opacity: 1')
                                }, null, 6),
                                (0, vue_2.createElementVNode)("i", {
                                    class: (0, vue_2.normalizeClass)(["marso-icon-sort-desc", sortDir.value === 'desc' ? 'text-white' : 'text-gray']),
                                    style: (0, vue_2.normalizeStyle)(sortDir.value !== 'desc' ? '--tw-text-opacity: 0.5' : '--tw-text-opacity: 1')
                                }, null, 6)
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (!(0, vue_2.unref)(currentRouteIsSkuSearch) &&
                        ((_e = (0, vue_2.unref)(filterValues)) === null || _e === void 0 ? void 0 : _e.itemCount) &&
                        typeof (0, vue_2.unref)(filterValues).itemCount.values === 'number' &&
                        (0, vue_2.unref)(filterValues).itemCount.values > (0, vue_2.unref)(tyre_search_1.MAX_HITS))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                            key: 6,
                            class: "my-4",
                            variant: "info"
                        }, {
                            message: (0, vue_2.withCtx)(() => [
                                (!zeroStockToggle.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("query_result_about_x_hits", "There are about {hits} hits. Please refine your filters.", "tyre_filter", {
                                        hits: (0, vue_2.unref)(i18n_1.n)((0, vue_2.unref)(currentHitsCount), "roundedDecimal"),
                                    })), 1))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("query_result_x_hits", "There are {hits} hits. Please refine your filters.", "tyre_filter", {
                                        hits: (0, vue_2.unref)(i18n_1.n)((0, vue_2.unref)(currentHitsCount), "roundedDecimal"),
                                    })), 1))
                            ]),
                            _: 1
                        }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.renderSlot)(_ctx.$slots, "additionalElements"),
                    (0, vue_2.createVNode)(ProductPopup_vue_1.default),
                    (0, vue_2.createVNode)(DiscountPopup_vue_1.default),
                    (0, vue_2.createVNode)(ProductListTable_vue_1.default, {
                        "sort-by": sortBy.value,
                        "onUpdate:sortBy": _cache[22] || (_cache[22] = ($event) => ((sortBy).value = $event)),
                        "sort-dir": sortDir.value,
                        "onUpdate:sortDir": _cache[23] || (_cache[23] = ($event) => ((sortDir).value = $event)),
                        products: (0, vue_2.unref)(products),
                        switches: {
                            zeroStockSwitch: zeroStockToggle.value,
                            setSwitch: tyreSetStockToggle.value,
                            retailPriceSwitch: retailPriceToggle.value,
                            grossPriceSwitch: showGrossPriceToggle.value,
                            pairSearchSwitch: pairSearchToggle.value,
                            customPriceSwitch: (0, vue_2.unref)(customDesignStore).isCustomPriceViewActive
                        }
                    }, null, 8, ["sort-by", "sort-dir", "products", "switches"])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
